/**
 * The shape every setup step's last run is reported in: the Android and Apple checklist rows and
 * the setup-graph nodes. Its own file because `./index` re-exports `./setup-graph`, so neither can
 * import the other's copy.
 */

import { z } from 'zod'

export const SetupLastRunSchema = z.object({
  state: z.enum(['starting', 'running', 'done', 'needs_attention', 'failed']),
  startedAt: z.string(),
  finishedAt: z.string().nullable(),
  detail: z.string().nullable(),
  /**
   * Runner output, relative to the repo root on the backend host — `null` for a HOSTED run, whose
   * log is in the ECS task rather than on any host the operator can open a file on.
   */
  logPath: z.string().nullable()
})
